<template>
  <div>
    <keep-alive>
      <hello></hello>
    </keep-alive>
  </div>
</template>
<script>
  import hello from './Hello'
  export default {
    components: {
      hello
    }
  }
</script>



// WEBPACK FOOTER //
// helloParent.vue?26f30268